// src/App.js
import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import LandingPage from './components/LandingPage';
import Register from './components/Register'; // Ensure this matches where you saved Register.js
import Security from './components/Security';
import LegalDoc from './components/LegalDoc';
import FeaturePage from './components/FeaturePage';
import CompanyPage from './components/CompanyPage';
const App = () => {
  return (
    <Router>
      <Routes>
        {/* If URL is "/", show Landing Page */}
        <Route path="/" element={<LandingPage />} />
        
        {/* If URL is "/register", show Register Page */}
        <Route path="/register" element={<Register />} />
        <Route path="/security" element={<Security />} />
        <Route path="/privacy" element={<LegalDoc type="privacy" />} />
        <Route path="/terms" element={<LegalDoc type="terms" />} />
        <Route path="/gdpr" element={<LegalDoc type="gdpr" />} />
        {/* 2. Platform Feature Routes */}
        <Route path="/permits" element={<FeaturePage type="permits" />} />
        <Route path="/daily-log" element={<FeaturePage type="daily-log" />} />
        <Route path="/registry" element={<FeaturePage type="registry" />} />
        <Route path="/assets" element={<FeaturePage type="assets" />} />
        <Route path="/audits" element={<FeaturePage type="audits" />} />
        <Route path="/incidents" element={<FeaturePage type="incidents" />} />
        <Route path="/corrective-actions" element={<FeaturePage type="corrective" />} />
        <Route path="/inductions" element={<FeaturePage type="inductions" />} />
        {/* 2. Company Routes */}
        <Route path="/about" element={<CompanyPage type="about" />} />
        <Route path="/careers" element={<CompanyPage type="careers" />} />
        <Route path="/partners" element={<CompanyPage type="partners" />} />
        <Route path="/contact" element={<CompanyPage type="contact" />} />
      </Routes>
    </Router>
  );
};

export default App;